<template functional>
  <q-btn v-if="props.show" round flat size="sm" :icon="props.iconClass" v-on="listeners">
    <LmTooltip v-if="props.tooltip">
      {{ props.tooltip }}
    </LmTooltip>
  </q-btn>

  <q-btn v-else round flat size="sm" style="visibility: hidden"></q-btn>
</template>

<script>
export default {
  props: {
    iconClass: {
      type: String,
      default: 'fas fa-pencil'
    },
    tooltip: String,
    show: Boolean
  }
}
</script>
